import React, { Component }  from 'react';
import TextField from '@material-ui/core/TextField';
import Search from '@material-ui/icons/Search';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class SearchBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            textFieldValue: ""
        };
        this._handleTextFieldChange = this._handleTextFieldChange.bind(this);
      }
    
    componentDidMount() {
        this.setState({textFieldValue: this.props.searchText});
    }

    _handleTextFieldChange(e) {
        this.setState({
            textFieldValue: e.target.value
        });
    };

    enterPressed(event) {
        var code = event.keyCode || event.which;
        if(code === 13) { 
            this.props.SearchOrders(this.state.textFieldValue)
        } 
    }

    render() {
        return (
            <div className="searchBox">
                <Trans>{t('SearchLabel')}</Trans>
                <Grid container spacing={3}>
                    <Grid item xs={9}>
                        <TextField
                            value={this.state.textFieldValue} onChange={this._handleTextFieldChange}
                            id="input-with-icon-textfield"
                            fullWidth
                            onKeyPress={this.enterPressed.bind(this)}
                            InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                <Search />
                                </InputAdornment>
                            ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Button onClick={() => this.props.SearchOrders(this.state.textFieldValue)} color="secondary" fullWidth variant="contained">{<Trans>{t('Continue')}</Trans>}</Button>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default SearchBox;